export const splitNames = (items) => {
  // 結合された名前はあるが、分割の名前がないとき
  if (
    !(items['last_name'] || items['first_name']) && items['name']
  ) {
    return {
      last_name: items['name'].split(' ')[0],
      first_name: items['name'].split(' ')[1]
    };
  }

  // 結合された名前はあるが、分割の名前がないとき
  // 結語された名前は更新の対象が増えるだけなので保持しない。
  // 必要であればサーバ側が結合して保存する
  if (items['last_name'] && items['first_name']) {
    return {
      last_name: items['last_name'],
      first_name: items['first_name']
    };
  }

  // それ以外の場合は全て初期値
  // 例えば、(ありえないはずだが)last_*だけ設定されているとか。
  return {
    last_name: '',
    first_name: ''
  };
};

export const splitNamesKana = (items) => {
  if (
    !(items['last_name_kana'] || items['first_name_kana']) && items['name_kana']
  ) {
    return {
      last_name_kana: items['name_kana'].split(' ')[0],
      first_name_kana: items['name_kana'].split(' ')[1]
    };
  }

  if (items['last_name_kana'] && items['first_name_kana']) {
    return {
      last_name_kana: items['last_name_kana'],
      first_name_kana: items['first_name_kana']
    };
  }

  return {
    last_name_kana: '',
    first_name_kana: ''
  };
};

// 問い合わせ履歴の補完時に海外を過去に選択した人がいる。
// ただし、「海外」はスライドフォーム上では選択肢に出さない為、異常値として扱い
// 代わりに「東京都」として都道府県を補完する
// apps/pcareer/app/javascript/javascripts/pages/common/form/vuex/store.js からロジックを流用
export const prefectureIdExpectOverSea = (id) => {
  if (!id) return null;
  const OVERSEA = 99;
  const TOKYO = 13;
  const MAX_NUMBER_OF_PREFECTURES = 47;

  // 99の判定と 48以上の判定が重複しているが
  //   99 -> 海外
  //   48以上 -> 意図しない異常値
  // という扱い。都道府県が増えることがあったらここはメンテナンスが必要。

  if (id == OVERSEA || Number(id) > MAX_NUMBER_OF_PREFECTURES) {
    return TOKYO;
  }

  return id;
};

const state = {
  company_id: null,
  position_id: null,
  kind: null,
  employment_type: null,
  wishful_time: null,
  position_type_codes: [],
  last_name: null,
  first_name: null,
  last_name_kana: null,
  first_name_kana: null,
  age: null,
  prefecture_id: null,
  city_id: null,
  phone: null,
  email: null,
  message: null,
  work_status: null,
  sex: null,
  experiences_attributes: [
    { position_type: null, year: null }
  ],
  agent_selection_auction_ids: [],
  without_reduced_params_flag: false,
  position_ids: [],
  // 以下、登録販売者と調剤事務・医療事務専用のvuex値
  qualified: null,
  work_experience: null
};

const actions = {
  initPresetData({ dispatch }, preset_data) {
    dispatch('setCompanyId', preset_data.company_id);
    dispatch('setPositionId', preset_data.position_id);
    dispatch('setEmploymentType', preset_data.employment_type);
    dispatch('setWishfulTime', preset_data.wishful_time);
    dispatch('setPositionTypeCodes', preset_data.position_type_codes);
    dispatch('setAge', preset_data.age);
    dispatch('setPhone', preset_data.phone);
    dispatch('setEmail', preset_data.email);
    dispatch('setMessage', preset_data.message);
    dispatch('setWorkStatus', preset_data.work_status);
    dispatch('setSex', preset_data.sex);
    dispatch('setKind', preset_data.kind);
    dispatch('setPositionIds', preset_data.position_ids);
    dispatch('setQualified', preset_data.qualified);
    dispatch('setWorkExperience', preset_data.work_experience);

    // first_nameとlast_nameは専用の関数で作りだす必要がある
    const nameData = splitNames(preset_data);
    dispatch('setLastName', nameData.last_name);
    dispatch('setFirstName', nameData.first_name);

    const nameKanaData = splitNamesKana(preset_data);
    dispatch('setLastNameKana', nameKanaData.last_name_kana);
    dispatch('setFirstNameKana', nameKanaData.first_name_kana);

    // prefecture_idは独自の計算方法がある
    const prefectureId = prefectureIdExpectOverSea(preset_data.prefecture_id);
    dispatch('setPrefectureId', prefectureId);

    // 経験年数はネスト化している
    if (preset_data.experience_position_type !== null) {
      dispatch('setExperiencesAttributes', {
        index: 0, value: {
          position_type: preset_data.experience_position_type,
          year: preset_data.experience_year
        }
      });
    }
    if (preset_data.experience_position_type2 !== null) {
      dispatch('setExperiencesAttributes', {
        index: 1, value: {
          position_type: preset_data.experience_position_type2,
          year: preset_data.experience_year2
        }
      });
    }
    if (preset_data.experience_position_type3 !== null) {
      dispatch('setExperiencesAttributes', {
        index: 2, value: {
          position_type: preset_data.experience_position_type3,
          year: preset_data.experience_year3
        }
      });
    }
  },
  setCompanyId({ commit }, value) {
    commit('SET_COMPANY_ID', value);
  },
  setPositionId({ commit }, value) {
    commit('SET_POSITION_ID', value);
  },
  setEmploymentType({ commit }, value) {
    commit('SET_EMPLOYMENT_TYPE', value);
  },
  setWishfulTime({ commit }, value) {
    commit('SET_WISHFUL_TIME', value);
  },
  setPositionTypeCodes({ commit }, value) {
    commit('SET_POSITION_TYPE_CODES', value);
  },
  setLastName({ commit }, value) {
    commit('SET_LAST_NAME', value);
  },
  setFirstName({ commit }, value) {
    commit('SET_FIRST_NAME', value);
  },
  setLastNameKana({ commit }, value) {
    commit('SET_LAST_NAME_KANA', value);
  },
  setFirstNameKana({ commit }, value) {
    commit('SET_FIRST_NAME_KANA', value);
  },
  setAge({ commit }, value) {
    commit('SET_AGE', value);
  },
  setPrefectureId({ commit }, value) {
    commit('SET_PREFECTURE_ID', value);
  },
  setCityId({ commit }, value) {
    commit('SET_CITY_ID', value);
  },
  setPhone({ commit }, value) {
    commit('SET_PHONE', value);
  },
  setEmail({ commit }, value) {
    commit('SET_EMAIL', value);
  },
  setMessage({ commit }, value) {
    commit('SET_MESSAGE', value);
  },
  setWorkStatus({ commit }, value) {
    commit('SET_WORK_STATUS', value);
  },
  setSex({ commit }, value) {
    commit('SET_SEX', value);
  },
  setExperiencesAttributes({ commit, state }, { index, value }) {
    const newValue = Object.assign(state.experiences_attributes, { [index]: value });
    commit('SET_EXPERIENCES_ATTRIBUTES', newValue);
  },
  deleteExperiencesAttributes({ commit, state }, key) {
    const newValue = Object.assign(state.experiences_attributes);
    delete newValue[key];
    commit('SET_EXPERIENCES_ATTRIBUTES', newValue);
  },
  setAgentSelectionAuctionIds({ commit }, value) {
    commit('SET_AGENT_SELECTION_AUCTION_IDS', value);
  },
  setWithoutReducedParamsFlag({ commit }, value) {
    commit('SET_WITHOUT_REDUCED_PARAMS_FLAG', value);
  },
  setKind({ commit }, value) {
    commit('SET_KIND', value);
  },
  setPositionIds({ commit }, value) {
    commit('SET_POSITION_IDS', value);
  },

  setQualified({ commit }, value) {
    commit('SET_QUALIFIED', value);
  },
  setWorkExperience({ commit }, value) {
    commit('SET_WORK_EXPERIENCE', value);
  }
};

const getters = {
  name(state) {
    if (!state.last_name || !state.first_name) {
      return '';
    }
    return `${state.last_name} ${state.first_name}`;
  },
  name_kana(state) {
    if (!state.last_name_kana || !state.first_name_kana) {
      return '';
    }
    return `${state.last_name_kana} ${state.first_name_kana}`;
  },
  isSegmentedAge(state) {
    return state.age >= 25 && state.age <= 49;
  },
  hasPositionIds(state) {
    return state.position_ids && state.position_ids.length > 0
  }
};

const mutations = {
  SET_COMPANY_ID(state, value) {
    state.company_id = value;
  },
  SET_POSITION_ID(state, value) {
    state.position_id = value;
  },
  SET_EMPLOYMENT_TYPE(state, value) {
    state.employment_type = value;
  },
  SET_WISHFUL_TIME(state, value) {
    state.wishful_time = value;
  },
  SET_POSITION_TYPE_CODES(state, value) {
    state.position_type_codes = value;
  },
  SET_LAST_NAME(state, value) {
    state.last_name = value;
  },
  SET_FIRST_NAME(state, value) {
    state.first_name = value;
  },
  SET_LAST_NAME_KANA(state, value) {
    state.last_name_kana = value;
  },
  SET_FIRST_NAME_KANA(state, value) {
    state.first_name_kana = value;
  },
  SET_AGE(state, value) {
    state.age = value;
  },
  SET_PREFECTURE_ID(state, value) {
    state.prefecture_id = value;
  },
  SET_CITY_ID(state, value) {
    state.city_id = value;
  },
  SET_PHONE(state, value) {
    state.phone = value;
  },
  SET_EMAIL(state, value) {
    state.email = value;
  },
  SET_MESSAGE(state, value) {
    state.message = value;
  },
  SET_WORK_STATUS(state, value) {
    state.work_status = value;
  },
  SET_SEX(state, value) {
    state.sex = value;
  },
  SET_EXPERIENCES_ATTRIBUTES(state, value) {
    state.experiences_attributes = { ...state.experiences_attributes, ...value };
  },
  SET_AGENT_SELECTION_AUCTION_IDS(state, value) {
    state.agent_selection_auction_ids = value;
  },
  SET_WITHOUT_REDUCED_PARAMS_FLAG(state, value) {
    state.without_reduced_params_flag = value;
  },
  SET_KIND(state, value) {
    state.kind = value;
  },
  SET_POSITION_IDS(state, value) {
    state.position_ids = value;
  },
  SET_QUALIFIED(state, value) {
    state.qualified = value;
  },
  SET_WORK_EXPERIENCE(state, value) {
    state.work_experience = value;
  }
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations
};